import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/*
 * The typeface, self-hosted, and imported BEFORE the stylesheet that names it.
 *
 * `--sans` has read `"Inter", system-ui, ...` since the theme was written and
 * nothing ever loaded the face, so every machine painted its own fallback and
 * the product looked different on each one. The heading `letter-spacing:-0.01em`
 * was tuned for a face that had never rendered.
 *
 * Self-hosted rather than Google Fonts on purpose: this console is reached over
 * the VPN, where a request to fonts.gstatic.com is a hang, not a fallback.
 */
import '@fontsource-variable/inter';

import { App } from './App.tsx';
import './theme.css';

/**
 * Set the theme BEFORE first paint.
 *
 * The predecessor's dark mode was applied after load, so every page flashed
 * light first. The rule that came out of fixing it: the authoritative test of
 * dark mode is a page that LOADED dark, not one toggled afterwards.
 */
document.documentElement.dataset['theme'] = localStorage.getItem('cosmon-theme') ?? 'dark';

const root = document.getElementById('root');
if (root === null) throw new Error('no #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
